import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogErrorContainer } from './dialog-error.container';
import { VshcDialogModule } from 'libs/core/src/dialog';

@NgModule({
  declarations: [
    DialogErrorContainer
  ],
  imports: [
    CommonModule,
    VshcDialogModule
  ],
  exports: [
    DialogErrorContainer
  ]
})
export class ZefDialogErrorModule {

}
